<template>
	<span v-if="hasOverview">
		<v-dialog width="500px" v-model="dialog">
			<template v-slot:activator="{ on }">
				<v-btn icon small color="black" text v-on="on">
					<v-icon small>mdi-account-group</v-icon>
					<v-badge color="green" v-if="waiting" left :content="waiting">
					</v-badge>
				</v-btn>
			</template>
			<v-card>
				<v-card-title>Meeting Participants</v-card-title>
				<v-card-text class="overview-table">
					<div>
						<v-row v-for="participant in participants" :key="participant.user">
							<v-col><span class="subtitle-1 mr-2">{{participant.screenName}}</span> 
								<v-chip dark x-small :color="statusColor(participant.status)">{{prettyPrint(participant.status)}}</v-chip>
							<br/>
							{{participant.email}} <span v-if="participant.phone && participant.email">|</span> {{participant.phone}}</v-col>
							<v-col class="text-right" cols="3">
								<span v-if="participant.status == 'waiting_room'">
									<v-btn icon text small color="green" @click="admit(participant.user)">
										<v-icon>mdi-check-circle</v-icon>
									</v-btn>
									<v-btn icon text small color="red" @click="deny(participant.user)">
										<v-icon>mdi-close-circle</v-icon>
									</v-btn>
								</span>
								<span v-if="participant.status == 'joined'">
									<v-icon small color="black" class="mr-2" v-if="participant.incognito">mdi-incognito</v-icon>
									<v-icon small v-else class="mr-2" color="grey">mdi-incognito-off</v-icon>
									<v-icon small color="black" class="mr-2" v-if="participant.video">mdi-video</v-icon>
									<v-icon small v-else class="mr-2" color="grey">mdi-video-off</v-icon>
									<v-icon small color="black" class="mr-2" v-if="participant.audio">mdi-microphone</v-icon>
									<v-icon small v-else class="mr-2" color="grey">mdi-microphone-off</v-icon>
								</span>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red" @click="dialog = false" dark> Close </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</span>
</template>

<style lang="less">
	.overview-table {
		font-size: 0.8em;
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import {prettyPrint} from "@/assets/utilities"
	export default {
		name: "RoomOverview", 
		props: {
			room: {}
		},
		data: () => {
			return {
				dialog: false
			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user,
				role: state => state.auth.view,
				video_room: state => state.video, 
				participants: state => state.video.participants
			}),
			hasOverview(){
				return this.role == "client" || this.role == "admin"
			},
			waiting(){
				return this.participants.filter( p => p.status == "waiting_room" ).length;
			}
		},
		methods: {
			prettyPrint: prettyPrint,
			statusColor(status){
				if( status == "denied" ){
					return "red"
				}
				if( status == "joined"){
					return "green"
				}
				if( status == "access_granted" ){
					return "primary"
				}
				return "secondary"
			}, 
			admit( user ){
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${user}`, 
					data: {
						status: "access_granted",
					},
					action: "update"
				})
			},
			deny( user ){
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${user}`, 
					data: {
						status: "access_denied",
					},
					action: "update"
				})
			}
		}
		// created(){
			
		// }

	}
// </script>"